module.exports = __webpack_public_path__ + "img/icon-halal.a386d27e.png";